import type { OpsPhoneItemKey } from '../../../functions-common/src/ops/phoneItems'

interface MemberOpsStoreSnapshot {
  opsPhoneItems: OpsPhoneItemKey[]
  opsPhoneItemsByWorkspace: Record<string, OpsPhoneItemKey[]>
}

let snapshot: MemberOpsStoreSnapshot = {
  opsPhoneItems: [],
  opsPhoneItemsByWorkspace: {},
}

type Listener = (snapshot: MemberOpsStoreSnapshot) => void
const listeners = new Set<Listener>()

const emit = (): void => {
  listeners.forEach((listener) => {
    try {
      listener(snapshot)
    } catch {
      // ignore
    }
  })
}

export const setMemberOpsPhoneItemsForWorkspace = (
  workspaceId: string,
  items: OpsPhoneItemKey[],
): void => {
  const current = snapshot.opsPhoneItemsByWorkspace[workspaceId]
  if (
    current &&
    current.length === items.length &&
    current.every((item, idx) => item === items[idx])
  ) {
    return
  }
  const nextByWorkspace = {
    ...snapshot.opsPhoneItemsByWorkspace,
    [workspaceId]: items,
  }
  snapshot = {
    ...snapshot,
    opsPhoneItemsByWorkspace: nextByWorkspace,
    opsPhoneItems: items,
  }
  emit()
}

export const getMemberOpsPhoneItems = (workspaceId?: string | null): OpsPhoneItemKey[] => {
  if (!workspaceId) return snapshot.opsPhoneItems ?? []
  return snapshot.opsPhoneItemsByWorkspace[workspaceId] ?? []
}

export const subscribeMemberOpsStore = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const resetMemberOpsStore = (): void => {
  snapshot = {
    opsPhoneItems: [],
    opsPhoneItemsByWorkspace: {},
  }
  emit()
}
